// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__16tSu","icon":"styles_icon__17CWI"};